export default __webpack_public_path__ + "static/media/img11.c5add99c.png";